import {urlParams} from 'utils/urlParams'

import {getPersistedUserCountryCode} from '@vio/core/src/_web/userConfig/userCountry'
import {
  defaultCountry,
  getTaxDisplayLogic
} from '@vio/core/src/localization/business/countries'
import {updateAllPrices} from '@vio/core/src/room/business/transformSapiRoomsResponse/decoratePrices'

import type {Price as BookingPrice} from '@vio/core/src/api-types/bovio/response/booking'
import type {Price as OffercheckPrice} from '@vio/core/src/api-types/bovio/response/offer_check'
import type {OfferPrice} from '@vio/core/src/offer/types/offer'

export const updatePrices = (
  prices: BookingPrice[] | OffercheckPrice[],
  checkIn: string,
  checkOut: string
): OfferPrice[] => {
  const {rooms} = urlParams()
  // Cookie set by persistUserCountryCodeInServerContext
  const userCountry = getPersistedUserCountryCode() || defaultCountry.code

  const taxDisplayLogic = getTaxDisplayLogic(userCountry)

  return prices.map(price =>
    updateAllPrices(price, {checkIn, checkOut, rooms}, taxDisplayLogic)
  )
}
